"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatBrowser = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
exports.ChatBrowser = styled_1.default.div((props) => ({
    backgroundColor: constants_1.Color.WHITE,
    borderRight: `${constants_1.theme.border.width.thin}px solid ${constants_1.Color.MEDIUM_GREY}`,
    display: props.isBrowsing ? 'flex' : 'none',
    flexDirection: 'column',
    flexShrink: 0,
    height: '100%',
    width: '100%',
    '@media (min-width: 1200px)': {
        display: 'flex',
        width: '352px',
    },
}));
